import { gql } from "@apollo/client";
export default gql`
  mutation AddOnTest($state: String!, $data: String!, $tests: [String!]!, $panels: [String!]!, $priority: String!) {
    addOnTest(state: $state, data: $data, tests: $tests, panels: $panels, priority: $priority)
  }
`;
